const siteURL = 'https://mealwell.com/';
const backURL = 'https://api.mealwell.com/';

const config = {
  siteURL,
  backURL,
  apiURL: `${backURL}api/v1/`,
  pdfURL: `${backURL}api/v1.1/pdf-products`
};

export default config;

